import { actions } from './actions'

const initialState = {
  usuarios: {
    data: [],
    loading: false,
    error: '',
  },
  usuario: {
    data: null,
    loading: false,
    error: '',
  },
  usuarioPerfil: {
    data: null,
    loading: false,
    error: '',
  },
  usuarioMenuKeys: {
    data: null,
    loading: false,
    error: '',
  },
  usuarioStock: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function usuarioReducer(state = initialState, action) {
  switch (action.type) {
    case actions.USUARIOS_LOAD_REQUESTED:
      return { ...state, usuarios: { ...state.usuarios, loading: true } }
    case actions.USUARIOS_LOAD_SUCCEEDED:
      return {
        ...state,
        usuarios: { ...state.usuarios, data: action.payload, loading: false },
      }
    case actions.USUARIOS_LOAD_FILED:
      return {
        ...state,
        usuarios: { ...state.usuarios, loading: false, error: action.error },
      }
    case actions.USUARIOS_TREE_LOAD_REQUESTED:
      return { ...state, usuarios: { ...state.usuarios, loading: true } }
    case actions.USUARIOS_TREE_LOAD_SUCCEEDED:
      return {
        ...state,
        usuarios: { ...state.usuarios, data: action.payload, loading: false },
      }
    case actions.USUARIOS_TREE_LOAD_FILED:
      return {
        ...state,
        usuarios: { ...state.usuarios, loading: false, error: action.error },
      }

    case actions.USUARIOS_TREE_LOAD_REQUESTED_FILTERED:
      return { ...state, usuarios: { ...state.usuarios, loading: true } }
    case actions.USUARIOS_TREE_LOAD_SUCCEEDED_FILTERED:
      return {
        ...state,
        usuarios: { ...state.usuarios, data: action.payload, loading: false },
      }
    case actions.USUARIOS_TREE_LOAD_FILED_FILTERED:
      return {
        ...state,
        usuarios: { ...state.usuarios, loading: false, error: action.error },
      }

    case actions.USUARIO_LOAD_BY_ID_INSERT_REQUESTED:
      return {
        ...state,
        usuario: { ...state.usuario, data: null, loading: false, error: '' },
      }
    case actions.USUARIO_UPDATE_REQUESTED:
      return {
        ...state,
        usuario: { ...state.usuario, loading: true, error: '' },
      }
    case actions.USUARIO_UPDATE_SUCCEEDED:
      return {
        ...state,
        usuario: { ...state.usuario, data: action.payload, loading: false, error: '' },
      }
    case actions.USUARIO_UPDATE_FILED:
      return {
        ...state,
        usuario: { ...state.usuario, loading: false, error: action.error },
      }
    case actions.USUARIO_INSERT_REQUESTED:
      return {
        ...state,
        usuario: { ...state.usuario, loading: true, error: '' },
      }
    case actions.USUARIO_INSERT_SUCCEEDED:
      return {
        ...state,
        usuario: { ...state.usuario, data: action.payload, loading: false, error: '' },
      }
    case actions.USUARIO_INSERT_FILED:
      return {
        ...state,
        usuario: { ...state.usuario, loading: false, error: action.error },
      }
    case actions.USUARIO_DELETE_REQUESTED:
      return {
        ...state,
        usuarios: { ...state.usuarios, loading: true, error: '' },
      }
    case actions.USUARIO_DELETE_SUCCEEDED:
      return {
        ...state,
        usuarios: {
          ...state.usuarios,
          data: state.usuarios.data.filter(usuario => usuario.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.USUARIO_DELETE_FILED:
      return {
        ...state,
        usuarios: { ...state.usuarios, loading: false, error: action.error },
      }
    case actions.USUARIO_LOAD_BY_ID_REQUESTED:
      return { ...state, usuario: { ...state.usuario, loading: true } }
    case actions.USUARIO_LOAD_BY_ID_SUCCEEDED:
      return {
        ...state,
        usuario: { ...state.usuario, data: action.payload, loading: false },
      }
    case actions.USUARIO_LOAD_BY_ID_FILED:
      return {
        ...state,
        usuario: { ...state.usuario, loading: false, error: action.error },
      }

    case actions.USUARIO_LOAD_BY_ID_PERFIL_REQUESTED:
      return { ...state, usuarioPerfil: { ...state.usuarioPerfil, loading: true } }
    case actions.USUARIO_LOAD_BY_ID_PERFIL_SUCCEEDED:
      return {
        ...state,
        usuarioPerfil: { ...state.usuarioPerfil, data: action.payload, loading: false },
      }
    case actions.USUARIO_LOAD_BY_ID_PERFIL_FILED:
      return {
        ...state,
        usuarioPerfil: { ...state.usuarioPerfil, loading: false, error: action.error },
      }

    case actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_REQUESTED:
      return { ...state, usuarioMenuKeys: { ...state.usuarioMenuKeys, loading: true } }
    case actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_SUCCEEDED:
      return {
        ...state,
        usuarioMenuKeys: {
          ...state.usuarioMenuKeys,
          data: action.payload,
          loading: false,
        },
      }
    case actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_FAILED:
      return {
        ...state,
        usuarioMenuKeys: { ...state.usuarioMenuKeys, loading: false, error: action.error },
      }
    case actions.USUARIO_LOAD_STOCK_MANAGER_REQUESTED:
      return { ...state, usuarioStock: { ...state.usuarioStock, loading: true } }
    case actions.USUARIO_LOAD_STOCK_MANAGER_SUCCEEDED:
      return {
        ...state,
        usuarioStock: { ...state.usuarioStock, data: action.payload, loading: false },
      }
    case actions.USUARIO_LOAD_STOCK_MANAGER_FAILED:
      return {
        ...state,
        usuarioStock: { ...state.usuarioStock, loading: false, error: action.error },
      }
    default:
      return state
  }
}
